import {
  ADD_USERS_TO_LIST,
  CLEAR_USERS,
  DELETE_USERS_FROM_LIST,
  EDIT_USERS_IN_LIST,
  SET_USERS,
} from '../types/users-types';

import { usersInitialState } from 'store/initial-states/users-initial-state';

export const usersReducer = (state = usersInitialState, action) => {
  switch (action.type) {
    case SET_USERS:
      return action.payload;

    case ADD_USERS_TO_LIST:
      return [...state.users, action.payload];

    case EDIT_USERS_IN_LIST:
      return state.users.map((item) =>
        item.id === action.payload.id ? { ...item, ...action.payload.updatedData } : item
      );

    case DELETE_USERS_FROM_LIST:
      return state.users.filter((item) => item.id !== action.payload);

    case CLEAR_USERS:
      return usersInitialState;

    default:
      return state;
  }
};
